import { FilterProps } from '@awaze/design-system.components.filter'
import { TmsContextType } from '@awaze/mfe-common.contexts.tms'
import { AggregationFeatures } from '@awaze/mfe-common.types-and-mocks.one-search-client'

import { OPTIMIZELY_EVENTS } from 'src/constants'
import { OptimizelyDecisionsProps } from 'src/context/optimizely-decisions-context'
import { Assert } from 'src/utils/assert'
import { trackClientSideOptimizelyEvent } from 'src/utils/optimizely/trackOptimizelyEvent'

import { FeatureGroupIds } from '../Filters.types'

import { fireFacetClearAllEvent } from './TMSEvents/fireFacetClearAllEvent'
import { fireFacetRemovedEvent } from './TMSEvents/fireFacetRemovedEvent'
import { fireFacetSelectedEvent } from './TMSEvents/fireFacetSelectedEvent'

export interface FireFacetToggledProps {
  allFeatures: Array<FilterProps | AggregationFeatures>
  appliedFeatures: Array<string>
  clickedFeature: {
    featureId: string
    featureName: string
    featureGroup: string
    featureGroupId: FeatureGroupIds
  }
  tms: TmsContextType
  optiContext: OptimizelyDecisionsProps
}

export const fireFacetToggled = ({
  allFeatures,
  appliedFeatures,
  clickedFeature: {
    featureId: clickedFeatureId,
    featureName: clickedFeatureName,
    featureGroup: clickedFeatureGroup,
    featureGroupId: clickedFeatureGroupId,
  },
  tms,
  optiContext,
}: FireFacetToggledProps): void => {
  const isFeatureApplied = appliedFeatures.includes(clickedFeatureId)

  if (clickedFeatureGroupId === 'popularFeatures') {
    trackClientSideOptimizelyEvent(
      OPTIMIZELY_EVENTS.POPULAR_FEATURE_CLICK,
      optiContext,
    )
  }

  trackClientSideOptimizelyEvent(OPTIMIZELY_EVENTS.FEATURE_CLICK, optiContext)

  if (isFeatureApplied) {
    const clickedFeature = {
      featureGroup: clickedFeatureGroup,
      featureLabel: clickedFeatureName,
    }

    fireFacetRemovedEvent({
      clickedFeature,
      tms,
    })
  } else {
    const foundFeature = allFeatures.find(
      ({ featureId: currentFeatureId }) =>
        currentFeatureId.toString() === clickedFeatureId.toString(),
    )

    Assert.defined(foundFeature, 'Was not able to find toggled feature')

    const { count: matchedFeatureCount } = foundFeature

    const clickedFeature = {
      featureCount: matchedFeatureCount,
      featureGroup: clickedFeatureGroup,
      featureLabel: clickedFeatureName,
    }

    fireFacetSelectedEvent({
      clickedFeature,
      tms,
    })
  }
}

export interface FireFacetClearAllProps {
  tms: TmsContextType
}

export const fireFacetClearAll = ({ tms }: FireFacetClearAllProps): void => {
  fireFacetClearAllEvent({
    tms,
  })
}

export interface FireChipRemovedProps {
  clickedFeature: {
    featureName: string
    featureGroup: string
  }
  tms: TmsContextType
}

export const fireChipRemoved = ({
  clickedFeature: { featureName, featureGroup },
  tms,
}: FireChipRemovedProps): void => {
  const clickedFeature = {
    featureGroup,
    featureLabel: featureName,
  }

  fireFacetRemovedEvent({
    clickedFeature,
    tms,
  })
}
